import styled from "styled-components";

export const ExtraFeeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  height: auto;
`;
